<template>
  <div>
    <v-dialog v-model="dialog" max-width="700px">
      <v-card flat tile id="top">
        <v-toolbar dense flat color="white">
          <v-toolbar-title class="font-weight-bold">
            <v-icon class="mr-2">edit</v-icon>방문예약 신청사항 수정
          </v-toolbar-title>
        </v-toolbar>
        <v-divider class="ml-4 mr-4"></v-divider>

        <v-card outlined tile class="ma-4">
          <v-card-text class="mt-2 mb-2 pb-0">
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="CustomInfo.CustomNm" label="이름" disabled dense persistent-placeholder></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-if="editedItem.cLocal == 'Y'" v-model="editedItem.cCorpNmKor" label="업체명" dense disabled persistent-placeholder></v-text-field>
                <v-text-field v-else v-model="editedItem.cCorpNmEng" label="업체명" dense disabled persistent-placeholder></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="CustomInfo.Tel" label="전화번호" disabled dense persistent-placeholder></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card outlined tile class="ma-4 mb-0 essetial_card">
          <v-card-text class="mt-2 mb-2 pb-0">
            <v-row align="center">
              <v-col cols="12" sm="6" md="6">
                <v-select
                  v-model="editedItem.cPurpose"
                  :items="zPurPose"
                  @change="editedItem.cSubPurpose = '';"
                  placeholder="::선택하세요::"
                  v-if="editedItem.cPurpose != '직접입력'"
                  dense
                  return-object
                  persistent-placeholder
                >
                  <template v-slot:label>
                    방문목적<strong class="red--text">*</strong>
                  </template>
                </v-select>
                <v-text-field
                  v-model="editedItem.cDirPurpose"
                  v-if="editedItem.cPurpose == '직접입력'"
                  @click:append="editedItem.cDirPurpose = '';editedItem.cPurpose = '회의'"
                  dense
                  class="essetial_input"
                  append-icon="refresh"
                  persistent-placeholder
                  placeholder="직접입력"
                >
                  <template v-slot:label>
                    방문목적<strong class="red--text">*</strong>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="editedItem.cSubPurpose" :disabled="editedItem.cPurpose == '직접입력'" :class="{'' : editedItem.cPurpose != '직접입력'}" dense persistent-placeholder>
                  <template v-slot:label>
                    <div>방문목적 상세설명<strong v-if="editedItem.cPurpose != '직접입력'" class="red--text">*</strong></div>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-select
                  v-model="editedItem.cSort"
                  :items="zSort"
                  @change="DisableSelect()"
                  placeholder="::선택하세요::"
                  dense
                  persistent-placeholder
                >
                  <template v-slot:label>
                    구분<strong class="red--text">*</strong>
                  </template>
                </v-select>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="editedItem.cZone" @click:append-outer="ShowMapDialog()" append-outer-icon="map" class="essetial_input" dense readonly persistent-placeholder>
                  <template v-slot:label>
                    방문장소<strong class="red--text">*</strong>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <IronDate ref="IronDateRef" v-model="editedItem.sNowSelectDate" cLabelEs="방문일" @update="onDateRangeChange" @overmaxperiod="overmaxperiod" :bSelect="editedItem.cSort == '0'?true :false" :sMinDate="sToday" style="width:100%"/>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="editedItem.cWorkerList" @click:append-outer="SetAddWorker()" append-outer-icon="mdi-account-multiple-plus-outline" readonly dense persistent-placeholder>
                  <template v-slot:label>
                    방문자 선택<strong class="red--text">*</strong>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <div class="ma-4 d-flex">
          <div>차량 정보</div>
          <v-spacer></v-spacer>
          <div>
            <v-btn @click="zCarInfo.splice(-1,1);" class="font-weight-bold" small dark width="100px"><v-icon small class="mr-1">mdi-minus</v-icon><div class="text-caption">차량 삭제</div></v-btn>
            <v-btn @click="zCarInfo.push({CarType: '',CarNo: ''});" class="font-weight-bold ml-2" small dark width="100px"><v-icon small class="mr-1">mdi-plus</v-icon><div class="text-caption">차량 추가</div></v-btn>
          </div>
        </div>

        <v-card outlined tile class="ma-4 mb-0 essetial_card">
          <v-card-text class="mt-2 mb-2 pb-0">
            <v-row align="center">
              <v-col cols="12" sm="6" md="6" v-for="(item,index) in zCarInfo" :key="index">
                <div class="d-flex justify-space-between">
                  <v-text-field v-model="item.CarType" class="mr-2" label="차종" dense persistent-placeholder></v-text-field>
                  <v-text-field v-model="item.CarNo" class="ml-2" label="차량번호" dense persistent-placeholder></v-text-field>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <div align="right" class="pa-4">
          <v-divider class="mb-2"></v-divider>
          <v-btn @click="dialog = false;" class="mr-2" text><v-icon class="mr-1">mdi-close</v-icon>취소</v-btn>
          <v-btn @click="SetReqLog()" class="ml-2" dark><v-icon class="mr-1">save</v-icon>저장</v-btn>
        </div>
      </v-card>
    </v-dialog>
    <MapDialog ref="MapDialogRef" @SetMap="SetMap"/>
    <AddWorkerDialog ref="AddWorkerDialogRef" :bLongVisit="editedItem.cSort == '0' ? false : true" @onSelect="SelectWorker"/>

    <v-dialog v-model="bShowMsg" max-width="500" persistent>
      <v-card>
        <v-card-title class="headline font-weight-bold">
          <div>장기 출입시 증명사진이 필요합니다.</div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-5">
          <div>증명사진의 첨부가 누락되었습니다.</div>
          <div>{{ (30-cCircularTime)/10 }} 초후 정보 수정 화면으로 이동합니다.</div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import BasicInfo from "@/BasicInfo.js";
import axios from "axios";
import EventBus from "@/eventBus.js";
import { mapState } from "vuex";

import IronDate from '@/components/iron28Calendar/src/IronDate4.vue';
import Util from "../Util.js";

import MapDialog from "./MapDialog.vue";
import AddWorkerDialog from "./AddWorkerDialog.vue";
// import AddWorkerDialog from "./AddWorkerDialog1.vue";

export default {
  components: {
    IronDate,
    MapDialog,
    AddWorkerDialog,
  },

  data: () => ({
    dialog : false,
    bShowMsg : false,
    cCircularTime : 0,
    interval : {},
    zWorker : [],
    editedIndex : -1,
    sToday : Util.sFormatDate(Date()),
    editedItem : {
      cReqId : "",
      cCarNo : "",
      cCarType : "",
      cPurpose : "",
      cSort : "",
      sNowSelectDate :  Util.sFormatDate(Date()) + " ~ " +  Util.sFormatDate(Util.sTomorrowSel()),
      cStartDate : Util.sFormatDate(Date()),
      cSubPurpose : Util.sFormatDate(Util.sTomorrowSel()),
      cZone : "",
      cLocal : "",
      cCorpNmKor : "",
      cCorpNmEng : "",
      cDirPurpose : "",
      cWorkerList : "",
    },
    zMapZoneInfo : [],
    zCarInfo : [],
  }),
  computed: {
    ...mapState(["CustomInfo","zPurPose","zSort","zTimeM","zState"]),
  },

  created() {
  },

  mounted() {
  },

  beforeDestroy () {
    clearInterval(this.interval)
  },

  methods : {
    async ShowDialog(item,index){
      let res = await this.GetReqItemLog(item.cReqId);

      if (res.data.ResultCd == "00"){
        // this.editedItem = JSON.parse(JSON.stringify(item));
        this.dialog = true;

        this.editedIndex = index
        this.editedItem.cDirPurpose = "";
        this.editedItem.cWorkerList = ""

        this.editedItem.cReqId = item.cReqId
        this.editedItem.cCarNo = item.cCarNo
        this.editedItem.cCarType = item.cCarType
        this.editedItem.cPurpose = item.cPurpose
        this.editedItem.cSort = item.cSort
        this.editedItem.cStartDate = item.cStartDate.substring(0,10);
        this.editedItem.cEndDate = item.cEndDate.substring(0,10);
        this.editedItem.cSubPurpose = item.cSubPurpose
        this.editedItem.cZone = item.cZone

        this.editedItem.cLocal = item.cLocal
        this.editedItem.cCorpNmKor = item.cCorpNmKor
        this.editedItem.cCorpNmEng = item.cCorpNmEng

        if (item.cPurpose != "회의" && item.cPurpose != "공사" && item.cPurpose != "납품" && item.cPurpose != "유지보수") {
          this.editedItem.cPurpose = "직접입력"
          this.editedItem.cDirPurpose = item.cPurpose
        }


        if (this.editedItem.cSort == "0") {
          this.editedItem.sNowSelectDate = this.editedItem.cEndDate
        } else {
          this.editedItem.sNowSelectDate = this.editedItem.cStartDate + " ~ " +  this.editedItem.cEndDate;
        }

        let i =0
        this.zMapZoneInfo = [];
        for (i =0; i < res.data.Result1.length;i ++){
          this.zMapZoneInfo.push(res.data.Result1[i].cId)
        }

        this.zWorker = [];

        for (i =0; i < res.data.Result2.length;i ++){
          this.zWorker.push(res.data.Result2[i])
          if (i != res.data.Result2.length-1) {
            this.editedItem.cWorkerList = this.editedItem.cWorkerList + res.data.Result2[i].CustomNm + ", "
          } else {
            this.editedItem.cWorkerList = this.editedItem.cWorkerList + res.data.Result2[i].CustomNm
          }
        }

        this.zCarInfo = [];
        for (i =0; i < res.data.Result3.length;i ++){
          this.zCarInfo.push(res.data.Result3[i])
        }

        setTimeout(() => {
          var element =  document.getElementById("top");
          element.scrollIntoView({behavior : "smooth"})
        }, 10);
      } else {
        EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
      }
    },

    GetReqItemLog(cReqId) {
      var posData = {
        ReqId : cReqId,
        SiteId : this.CustomInfo.SiteId,
        CustomId : this.CustomInfo.CustomId,
        CorpId : this.CustomInfo.CorpId,
      };
      return new Promise((resolve) => (
        axios
        .post(process.env.VUE_APP_UIL_API + "GetReqItemLog", posData, {
          headers: {
            "Authorization": this.CustomInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          resolve(res);
        })
        .catch(err => {
          resolve(null);
          EventBus.$emit("onShowMsg", true,""+err);
        })
      ));
    },

    ShowMapDialog(){
      this.$refs.MapDialogRef.ShowDialog(this.zMapZoneInfo)
    },

    SetMap(zZone,zZoneNm){
      this.zMapZoneInfo = zZone
      this.editedItem.cZone = zZoneNm
    },

    overmaxperiod(value){
      EventBus.$emit("onShowMsgBox", value.sTitle,value.sMsg);
    },

    onDateRangeChange(daterange){
      this.editedItem.cStartDate = Util.sFormatDate(daterange.startDate);
      this.editedItem.cEndDate = Util.sFormatDate(daterange.endDate);
      this.editedItem.cEndDate == this.editedItem.cStartDate ? this.editedItem.cSort = "0": this.editedItem.cSort = "1"
      this.editedItem.cSort == "0" ? this.editedItem.sNowSelectDate = this.editedItem.cStartDate : this.editedItem.sNowSelectDate = this.editedItem.cStartDate + " ~ " +  this.editedItem.cEndDate
      this.editedItem.cWorkerList = ""
      this.zWorker = []

      this.$forceUpdate();
    },

    DisableSelect(){
      if (this.editedItem.cSort == "0") {
        this.editedItem.cEndDate = this.editedItem.cStartDate;
        this.editedItem.sNowSelectDate = this.editedItem.cStartDate
      } else {
        this.editedItem.cStartDate = Util.sFormatDate(Date());
        this.editedItem.cEndDate = Util.sFormatDate(Util.sTomorrowSel());
        this.editedItem.sNowSelectDate = this.editedItem.cStartDate + " ~ " +  this.editedItem.cEndDate;
      }
      this.editedItem.cWorkerList = "";
      this.zWorker = [];
    },

    SetAddWorker() {
      if (this.editedItem.cStartDate == "" || this.editedItem.cEndDate == "") {
        EventBus.$emit("onShowMsgBox","필수 입력 사항이 누락 되었습니다.","방문 시작일과 종료일을 선택 하여 주세요.");
        return
      }

      this.$refs.AddWorkerDialogRef.ShowDialog(this.editedItem, this.zWorker)
    },

    SelectWorker(zData){
      this.zWorker = [];
      this.editedItem.cWorkerList = ""
      
      for(var i = 0; i < zData.length; i++){
        this.zWorker.push(zData[i])

        if (i != zData.length-1) {
          this.editedItem.cWorkerList = this.editedItem.cWorkerList + zData[i].CustomNm + ", "
        } else {
          this.editedItem.cWorkerList = this.editedItem.cWorkerList + zData[i].CustomNm
        }
      }

      this.$forceUpdate();
    },

    CountTime() {
      this.interval = setInterval(() => {
        this.cCircularTime += 10
      }, 1000)
    },

    SetReqLog(){
      if (this.editedItem.cSort == "1" && (this.CustomInfo.FileId == "NONE" || this.CustomInfo.FileId == "")) {
        this.bShowMsg = true
        this.cCircularTime = 0;
        this.CountTime();
        setTimeout(() => {
          clearInterval(this.interval)
          this.bShowMsg = false
          this.dialog = false
          this.$router.push({name : "ChangeCustomInfo"})
        }, 3000);
        return
      }

      if (this.editedItem.cPurpose == "") {
        EventBus.$emit("onShowMsgBox", "필수 선택 사항이 누락되었습니다.","방문 목적을 선택하여 주세요.");
        return
      }

      if (this.editedItem.cPurpose != "직접입력" && this.editedItem.cSubPurpose == "") {
        EventBus.$emit("onShowMsgBox", "필수 선택 사항이 누락되었습니다.","방문 목적에 대한 부가 설명을 입력하여 주세요.");
        return
      }

      if (this.editedItem.cPurpose != "직접입력" && this.editedItem.cSubPurpose.length > 50) {
        EventBus.$emit("onShowMsgBox", "필수 선택 사항이 누락되었습니다.","방문 목적에 대한 부가 설명은 50자를 넘길 수 없습니다.");
        return
      }

      if (this.editedItem.cPurpose == "직접입력" && this.editedItem.cDirPurpose == "") {
        EventBus.$emit("onShowMsgBox", "필수 입력 사항이 누락되었습니다.","방문 목적을 입력하여 주세요.");
        return
      }

      if (this.editedItem.cSort == "ALL") {
        EventBus.$emit("onShowMsgBox", "필수 선택 사항이 누락되었습니다.","구분 항목을 선택하여 주세요.");
        return
      }

      if (this.editedItem.cSort == "0" && this.editedItem.cStartDate != this.editedItem.cEndDate) {
        EventBus.$emit("onShowMsgBox", "필수 선택 사항이 누락되었습니다.","일반 방문할 날짜를 선택 하여 주세요.");
        return
      }

      if (this.editedItem.cZone == "") {
        EventBus.$emit("onShowMsgBox", "필수 선택 사항이 누락되었습니다.","방문장소를 선택하여 주세요.");
        return
      }

      if (this.zWorker.length == 0) {
        EventBus.$emit("onShowMsgBox", "필수 선택 사항이 누락되었습니다.","방문자는 최소 1명 이상 선택하여 주세요.");
        return
      }


      if (this.editedItem.cPurpose == "직접입력") this.editedItem.cPurpose = this.editedItem.cDirPurpose;

      var posData = {}
      var zWorker = []

      for(let k = 0; k < this.zWorker.length; k ++){
        zWorker.push({
          CustomId : this.zWorker[k].CustomId,
          CustomNm : this.zWorker[k].CustomNm
        })
      }

      posData = {
        ReqId : this.editedItem.cReqId,
        SiteId : this.CustomInfo.SiteId,
        CustomId : this.CustomInfo.CustomId,
        CustomNm : this.CustomInfo.CustomNm,
        CorpId : this.CustomInfo.CorpId,
        Manager : this.CustomInfo.Manager,
        StartDate : this.editedItem.cStartDate,
        EndDate : this.editedItem.cEndDate,
        Purpose : this.editedItem.cPurpose,
        SubPurpose : this.editedItem.cSubPurpose,
        CarType : this.editedItem.cCarType,
        ChargeUserId : this.editedItem.cUserId,
        ChargeUserNm : this.editedItem.cUserNm,
        CarNo : this.editedItem.cCarNo,
        Zone : this.editedItem.cZone,
        MapTreeInfo : Util.ChangeArray(this.zMapZoneInfo),
        Sort : this.editedItem.cSort,
        WorkerInfo : zWorker,
        CarInfo : this.zCarInfo,
      }

      axios
        .post(process.env.VUE_APP_UIL_API + "SetReqLog", posData, {
          headers: {
           "Authorization": this.CustomInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd == "66") { EventBus.$emit("onChangeCorpInfo"); return; }
          if (res.data.ResultCd === "00") {
            EventBus.$emit("onShowMsg",false,  "수정이 완료되었습니다.");

            this.zWorker = [];
            this.$emit("ChangeReq",this.editedItem,this.editedIndex)
            this.dialog = false;
          } else if (res.data.ResultCd == "02") {
            EventBus.$emit("onShowMsgBox","삭제되었거나 승인된 사항입니다.", "화면을 다시 접속 하여 확인하여 주세요.");
          } else if (res.data.ResultCd == "06") {
            EventBus.$emit("onShowMsgBox","출입이 불가한 신청자가 있습니다.", "방문자 목록을 새로 고침 하여 상세한 내용을 확인하여 주세요.");
          } else if (res.data.ResultCd == "55") {
            EventBus.$emit("onShowMsgBox","출입 정지 기간 중입니다.", res.data.Msg);
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);        
        });
    },
  }
}
</script>